import { jsx as _jsx } from "react/jsx-runtime";
import { DateRangePicker as HeroDateRangePicker } from '@heroui/react';
export const DateRangePicker = (props) => {
    return _jsx(HeroDateRangePicker, { ...props });
};
//# sourceMappingURL=DateRangePicker.js.map